import { Stack, Typography } from '@mui/material';
import {
  HeaderContainer,
  MetaContainer,
  PageContainer,
  SearchContainer,
} from './pageStyles';
import SearchField from './SearchField';
import { DynamicFilterModal } from '../filters/DynamicFilterModal';
import { PageProps } from './PageTypes';
import { QuickFilters } from '../filters/QuickFilters';

export function PageComponent<FilterTypes = void>({
  title,
  onSearch = null,
  actions,
  children,
  quickFilters = null,
  dynamicFilters = null,
  searchPlaceholder,
  extraActions,
  searchType,
}: PageProps<FilterTypes>) {
  const renderDynamicFilters = () => {
    return (
      <DynamicFilterModal<FilterTypes>
        filters={dynamicFilters?.filters || []}
        storedFilters={dynamicFilters?.storedFilters}
        handleSaveFilters={dynamicFilters?.handleSaveFilters}
        handleDeleteFilter={dynamicFilters?.handleDeleteFilter}
        allowSaveFilters={dynamicFilters?.allowSaveFilters}
        handleOrderIndexBulkUpdate={dynamicFilters?.handleOrderIndexBulkUpdate}
        handleGroupsOrderIndexBulkUpdate={
          dynamicFilters?.handleGroupsOrderIndexBulkUpdate
        }
        handleSaveFilterGroup={dynamicFilters?.handleSaveFilterGroup}
        handleDeleteFilterGroup={dynamicFilters?.handleDeleteFilterGroup}
      />
    );
  };

  return (
    <PageContainer>
      <HeaderContainer
        hasDynamicFilters={!!dynamicFilters}
        hasQuickFilters={!quickFilters}
      >
        <SearchContainer>
          <Typography
            variant="h1"
            sx={{ fontWeight: 700, fontSize: '1.25rem' }}
            data-testid="page-title"
          >
            {title}
          </Typography>
          {onSearch && (
            <SearchField
              searchType={searchType}
              placeholder={searchPlaceholder}
              onSearch={onSearch}
              data-test-id="page-search-field"
            />
          )}
        </SearchContainer>

        <MetaContainer data-testid="page-meta">
          <Stack
            direction="row"
            spacing={2}
            justifyContent="center"
            alignItems="center"
          >
            {dynamicFilters && !quickFilters && (
              <div style={{ display: 'flex', alignItems: 'center' }}>
                {renderDynamicFilters()}
              </div>
            )}
            {actions}
          </Stack>
        </MetaContainer>
      </HeaderContainer>
      <div
        style={{
          backgroundColor: '#202632',
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'center',
          padding: '4px 0',
          margin: '1em 1.5em',
        }}
      >
        {quickFilters ? (
          <QuickFilters
            quickFilters={quickFilters?.filters}
            filterKey={quickFilters.filterKey}
            defaultValue={quickFilters.defaultValue}
          />
        ) : (
          <div></div>
        )}

        {dynamicFilters && quickFilters && (
          <Stack direction="row" alignItems="center" spacing={1}>
            {renderDynamicFilters()}
            {extraActions}
          </Stack>
        )}
      </div>
      <div style={{ margin: '0 1.5em' }}>{children}</div>
    </PageContainer>
  );
}

export default PageComponent;
